"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const _ActionTypes = require("./actionTypes");
const _Actions = require("./actions");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../../utils/errorHandling");
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const Actions = _Actions.default(namespace);
    function fetch(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'GET',
            url: `${baseUrl}api/bid/${action.payload}`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            const validation = t
                .intersection([
                t.interface({
                    path: t.array(sok_types_1.File.iFolder),
                    bid: sok_types_1.Bid.iBid,
                    features: t.number,
                    printProviders: t.array(t.number)
                }),
                t.partial({
                    documents: sok_types_1.File.iFolder,
                    attachments: sok_types_1.File.iFolder,
                    questions: sok_types_1.File.iFolder
                })
            ])
                .decode(xhr.response);
            const act = validation.fold((e) => [Actions.fetchFailed((0, errorHandling_1.parseValidationError)(e))], (res) => {
                const acts = [
                    Actions.fetchSuccess(res.bid, res.path, res.features, res.printProviders, res.documents, res.attachments, res.questions)
                ];
                return acts;
            });
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
    }
    function provides(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'GET',
            url: `${baseUrl}api/order/folder/${action.payload}/check-provided`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            const validation = t
                .interface({
                status: t.boolean
            })
                .decode(xhr.response);
            const act = validation.fold((e) => [
                Actions.fetchProvidesStatusFailed((0, errorHandling_1.parseValidationError)(e))
            ], (res) => {
                const acts = [
                    Actions.fetchProvidesStatusSuccess(res.status)
                ];
                return acts;
            });
            return (0, rxjs_1.of)(...act);
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchProvidesStatusFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
    }
    return { fetch, provides };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map